import React from 'react'
import styled from 'styled-components'

import { routes } from '@sketch/modules-common'

// Components
import { Link, Button, ErrorMessage } from '@sketch/components'

// Icons
import { ReactComponent as WorkspaceIcon } from '@sketch/icons/workspace-64'
import { ReactComponent as GlobeIcon } from '@sketch/icons/globe-64'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'
import { WorkspaceSidebarLayout } from 'modules/workspace/components/WorkspaceSidebarLayout/WorkspaceSidebarLayout'

const StyledErrorMessage = styled(ErrorMessage)<{ isPartner?: boolean }>`
  height: auto;
  max-width: ${({ isPartner }) => (isPartner ? '542px' : '480px')};
  flex: 1 0 auto;
  align-self: center;
  padding: 16px;
`

export const NoWorkspaceView = () => {
  const { data } = useGetInitialUserQuery()
  const isParner = data?.me.isPartner

  const children = (
    <>
      {isParner ? (
        <StyledErrorMessage
          title="You’re now a Sketch Partner"
          icon={<GlobeIcon />}
          isPartner
        >
          As a Sketch Partner, you can join Workspaces, and manage billing
          details and Editor Seats on behalf of your clients.
        </StyledErrorMessage>
      ) : (
        <StyledErrorMessage
          title="Create your first Workspace"
          icon={<WorkspaceIcon />}
          extra={
            <Link
              to={{
                pathname: routes.WORKSPACE_CREATE.create({}),
                state: { fromNoWorkspaces: true },
              }}
            >
              <Button variant="primary">Create Workspace</Button>
            </Link>
          }
        >
          Saved documents will display here. Kick off your{' '}
          <b>30-day free trial</b> by creating your first Workspace!
        </StyledErrorMessage>
      )}
    </>
  )

  return (
    <WorkspaceSidebarLayout title="No Workspaces" render={() => children} />
  )
}
